module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-6-ed9f39dc1dc9d36b1496bac84eeba9f8.jpg";